/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'report': {
    viewBox: '0 0 16 16',
    data: '<g><path d="M11,1V0H5v1H2v15h12V1H11z M6,1h4v2H6V1z M13.1,15.1H2.9V1.9H5V4h6V1.9h2.1V15.1z"/><rect x="4.5" y="6" width="1" height="7"/><rect x="7.5" y="10" width="1" height="3"/><rect x="10.5" y="8" width="1" height="5"/></g>'
  }
})
